import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { keyEmptyCheck } from 'aurora-utils/utils';

import { ADGMImage } from 'aurora-components';
import { Typography, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  uaePassBox: {
    display: 'flex',
    flexDirection: 'column',
    '@media (max-width: 600px)': {
      justifyContent: 'space-between',
      minHeight: '400px',
    },
  },
  title: {
    fontWeight: '600',
    fontSize: '24px',
    marginBottom: '25px',
    '@media (max-width: 600px)': {
      fontSize: '16px',
      textAlign: 'center',
    },
  },
  rejectedTooltip: {
    display: 'inline-flex',
    alignItems: 'center',
    background: '#FFF7ED',
    color: '#342D3D',
    border: '1px solid #D97706',
    fontSize: '12px',
    lineHeight: '1.5',
    fontWeight: '400',
    width: '100%',
    padding: '12px 30px 15px 12px',
    marginBottom: '20px',
    '& img': {
      marginRight: '8px',
    },
  },
  adgmRedBtn: {
    background: '#fff',
    color: '#000',
    border: '1px solid #000',
    borderRadius: '0px',
    fontWeight: '600',
    fontSize: '16px',
    textTransform: 'none',
    height: '60px',
    display: 'block',
    width: '100%',
    marginBottom: '30px',
    '& svg,img': {
      marginInlineEnd: theme.spacing(1),
    },
    '&:hover': {
      textDecoration: 'none',
    },
  },
  helpLink: {
    display: 'block',
    textAlign: 'center',
    color: '#0088FF',
    fontSize: '16px',
    fontWeight: '500',
  },
}));

const AuthContainer = ({ errorCode, errorDescription, uaePassErrorDescription, logOutWithUAEPass }) => {
  const history = useHistory();
  const classes = useStyles();
  let text = '';
  let image = 'passport';
  if (uaePassErrorDescription) {
    text = 'login_was_unsuccessful';
    image = 'error';
  } else if (errorCode && errorCode === '100') {
    text = 'login_was_unsuccessful';
    image = 'error';
  } else if (errorCode && errorCode === '838314') {
    text = 'login_was_unsuccessful';
    image = 'person';
  } else if (errorCode && errorCode === '838315') {
    text = 'login_was_unsuccessful';
    image = 'person';
  } else if (errorCode && errorCode === '838317') {
    text = 'login_was_unsuccessful';
    image = 'person';
  } else if (errorCode && errorCode === '838313') {
    text = 'login_was_unsuccessful';
    image = 'passport';
  } else if (errorCode && errorCode === '838303') {
    text = 'login_was_unsuccessful';
    image = 'passport';
  } else if (errorCode && errorCode === '838316') {
    text = 'issue_with_user_profile';
    image = 'error';
  } else if (errorCode && errorCode === 'VAL200002') {
    text = 'login_was_unsuccessful';
    image = 'person';
  } else if (localStorage.getItem('uae_pass_errorCode') === 'VAL200002') {
    localStorage.setItem('uae_pass_errorCode_count', '2');
    text = 'login_was_unsuccessful';
    image = 'person';
  } else {
    text = 'login_was_unsuccessful';
    image = 'error';
  }
  console.log(localStorage.getItem('uae_pass_errorCode'), image);
  useEffect(() => {
    if (errorCode === 'VAL200002') {
      localStorage.setItem('uae_pass_errorCode', errorCode);
      localStorage.setItem('uae_pass_errorCode_count', '1');

      logOutWithUAEPass(true); // eslint-disable-line
    }
  }, [errorCode]);
  if (localStorage.getItem('refresh_token') != null) {
    history.push('/app/home');
  }
  return (
    <Fragment>
      <Box className={classes.uaePassBox}>
        <Box>
          <Typography variant='h5' component='h1' className={classes.title}>
            {keyEmptyCheck(text)}
          </Typography>
          <span className={classes.rejectedTooltip}>
            <ADGMImage name='rejectionMsj.svg' alt='InformationImg' />
            {(errorCode && errorCode === '838314') ||
            errorCode === '838315' ||
            errorCode === 'VAL200002' ||
            localStorage.getItem('uae_pass_errorCode') === 'VAL200002'
              ? keyEmptyCheck('your_account_is_currently_not_upgraded_in_UAE_pass')
              : keyEmptyCheck(uaePassErrorDescription || 'uae_pass_login_exception')}
          </span>
        </Box>
      </Box>
    </Fragment>
  );
};

AuthContainer.propTypes = {
  errorCode: PropTypes.string.isRequired,
  errorDescription: PropTypes.string.isRequired,
  uaePassErrorDescription: PropTypes.string.isRequired,
  logOutWithUAEPass: PropTypes.func.isRequired,
};

export default AuthContainer;
